import React from 'react';
import cn from 'classnames';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import DaVideoPlayer from '../DaVideoPlayer';
import { useSize } from '../../hooks/useSize';
import { useEditorContainerSize } from '../../../../components/Editor/Context';

import s from './DaVideoView.scss';
import viewerStyles from '../../Viewer/Viewer.scss';

const VideoNodeView: React.FC<NodeViewProps> = ({
  node: { attrs },
  extension: { options },
}) => {
  const containerSize = useEditorContainerSize();

  const { width, height } = useSize(
    options.defaultWidth,
    options.defaultHeight,
    attrs.alignment,
    containerSize ?? 0
  );

  return (
    <NodeViewWrapper
      data-da-type="da-video"
      data-src={attrs.src}
      data-drag-handle="true"
      className={cn('draggable-atomic')}
    >
      <div
        className={cn(
          viewerStyles['video-wrapper'],
          viewerStyles[attrs.alignment],
          options.smallMedia && viewerStyles['small-media']
        )}
      >
        <DaVideoPlayer
          src={attrs.src}
          width={width}
          height={height}
          className={s['video-player']}
        />
      </div>
    </NodeViewWrapper>
  );
};

export default VideoNodeView;
